module.exports = __webpack_public_path__ + "static/media/new_pack_cat_en_768x350.db941fd2.png";